module.exports = __webpack_public_path__ + "static/media/edit.c80217a2.svg";